import './App.css';
import { useState, useEffect } from 'react';
import { LocationIcon, RulerIcon, BedIcon, BathIcon, HomeIcon, DollarIcon, HandshakeIcon, CheckCircleIcon, EmailIcon, PhoneIcon, MessageIcon, MapPinIcon, InstagramIcon, YoutubeIcon, CameraIcon, CheckIcon } from './Icons';

const API_URL = process.env.REACT_APP_API_URL || 'https://pakarealestate.in/api';

function App() {
  const [page, setPage] = useState('home');
  const [filter, setFilter] = useState('all');
  const [isAdmin, setIsAdmin] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);
  const [newProperty, setNewProperty] = useState({
    category: 'land',
    title: '',
    location: '',
    price: '',
    image: '',
    images: [],
    size: '',
    beds: '',
    baths: '',
    status: 'active'
  });
  const [allProperties, setAllProperties] = useState([]);
  const [editingProperty, setEditingProperty] = useState(null);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [lightboxImage, setLightboxImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState({});
  const [menuOpen, setMenuOpen] = useState(false);
  const [adminFilter, setAdminFilter] = useState('all');

  useEffect(() => {
    fetchProperties();
  }, []);

  const fetchProperties = async () => {
    try {
      const response = await fetch(`${API_URL}/properties`);
      const data = await response.json();
      const parsedData = data.map(prop => {
        const images = Array.isArray(prop.images) ? prop.images : (prop.images ? JSON.parse(prop.images) : []);
        console.log('Property', prop.id, 'has', images.length, 'images');
        return {
          ...prop,
          images: images
        };
      });
      setAllProperties(parsedData);
    } catch (error) {
      console.error('Error fetching properties:', error);
    }
  };

  const allLands = allProperties.filter(p => p.category === 'land');
  const allHousesForSale = allProperties.filter(p => p.category === 'sale');
  const allHousesForRent = allProperties.filter(p => p.category === 'rent');

  const handleLogin = (e) => {
    e.preventDefault();
    if (username === 'admin' && password === 'admin123') {
      setIsAdmin(true);
      setPage('admin');
    } else {
      alert('Invalid credentials');
    }
  };

  const handleLogout = () => {
    setIsAdmin(false);
    setUsername('');
    setPassword('');
    setPage('home');
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      const readers = files.map(file => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(file);
        });
      });
      
      Promise.all(readers).then(images => {
        setNewProperty({ 
          ...newProperty, 
          image: images[0],
          images: images
        });
      });
    }
  };

  const removeImage = (index) => {
    const newImages = newProperty.images.filter((_, i) => i !== index);
    setNewProperty({
      ...newProperty,
      images: newImages,
      image: newImages[0] || ''
    });
  };

  const handleAddProperty = async (e) => {
    e.preventDefault();
    const property = {
      category: newProperty.category,
      title: newProperty.title,
      location: newProperty.location,
      price: newProperty.price,
      image: newProperty.image || 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=400',
      size: newProperty.category === 'land' ? newProperty.size : null,
      beds: newProperty.category !== 'land' ? parseInt(newProperty.beds) : null,
      baths: newProperty.category !== 'land' ? parseInt(newProperty.baths) : null,
      status: newProperty.status,
      images: newProperty.images
    };
    console.log('Saving property with images:', property.images.length, 'images');

    try {
      if (editingProperty) {
        console.log('Updating property ID:', editingProperty.id);
        console.log('API URL:', `${API_URL}/properties/${editingProperty.id}`);
        const response = await fetch(`${API_URL}/properties/${editingProperty.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(property)
        });
        console.log('Response status:', response.status);
        const result = await response.json();
        console.log('Update response:', result);
        alert(`Property updated! Status sent: ${property.status}`);
        setEditingProperty(null);
      } else {
        await fetch(`${API_URL}/properties`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(property)
        });
        alert('Property added successfully!');
      }
      await fetchProperties();
      setNewProperty({ category: 'land', title: '', location: '', price: '', image: '', images: [], size: '', beds: '', baths: '', status: 'active' });
      setShowAddForm(false);
    } catch (error) {
      console.error('Error details:', error);
      alert('Error saving property: ' + error.message);
    }
  };

  const handleEditProperty = (property) => {
    setEditingProperty(property);
    setNewProperty({
      category: property.category,
      title: property.title,
      location: property.location,
      price: property.price,
      image: property.image,
      images: property.images || [],
      size: property.size || '',
      beds: property.beds || '',
      baths: property.baths || '',
      status: property.status || 'active'
    });
    setShowAddForm(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDeleteProperty = async (id) => {
    if (window.confirm('Are you sure you want to delete this property?')) {
      try {
        await fetch(`${API_URL}/properties/${id}`, { method: 'DELETE' });
        alert('Property deleted successfully!');
        fetchProperties();
      } catch (error) {
        alert('Error deleting property: ' + error.message);
      }
    }
  };
  const landsData = allLands;
  const housesForSaleData = allHousesForSale;
  const housesForRentData = allHousesForRent;

  return (
    <div className="App">
      <header className="header">
        <h1>Paka Real Estate</h1>
        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? '✕' : '☰'}
        </button>
        <nav className={menuOpen ? 'nav-open' : ''}>
          <a href="#home" onClick={() => { setPage('home'); setMenuOpen(false); }}>Home</a>
          <a href="#land" onClick={() => { setPage('land'); setMenuOpen(false); }}>Land for Sale</a>
          <a href="#sale" onClick={() => { setPage('sale'); setMenuOpen(false); }}>House for Sale</a>
          <a href="#rent" onClick={() => { setPage('rent'); setMenuOpen(false); }}>House for Rent</a>
          <a href="#about" onClick={() => { setPage('about'); setMenuOpen(false); }}>About</a>
          <a href="#contact" onClick={() => { setPage('contact'); setMenuOpen(false); }}>Contact</a>
          {isAdmin ? (
            <a href="#admin" onClick={() => { setPage('admin'); setMenuOpen(false); }}>Admin</a>
          ) : (
            <a href="#login" onClick={() => { setPage('login'); setMenuOpen(false); }}>Login</a>
          )}
        </nav>
      </header>

      {page === 'home' && (
      <>
      <section id="home" className="hero">
        <div className="hero-content">
          <h2>Find Your Dream Property</h2>
          <p>Discover the best real estate deals in town</p>
          <button className="hero-btn">Explore Properties</button>
        </div>
      </section>

      <section className="services-section">
        <h2>Our Services</h2>
        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon"><HomeIcon /></div>
            <h3>Renting</h3>
            <p>Find your perfect rental property with flexible terms and prime locations</p>
          </div>
          <div className="service-card">
            <div className="service-icon"><DollarIcon /></div>
            <h3>Buying</h3>
            <p>Invest in your dream home or land with expert guidance and support</p>
          </div>
          <div className="service-card">
            <div className="service-icon"><HandshakeIcon /></div>
            <h3>Selling</h3>
            <p>Get the best value for your property with our professional marketing</p>
          </div>
          <div className="service-card">
            <div className="service-icon"><CheckCircleIcon /></div>
            <h3>Approvals</h3>
            <p>Complete assistance with legal documentation and government approvals</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="filter-bar">
          <button className={filter === 'all' ? 'filter-btn active' : 'filter-btn'} onClick={() => setFilter('all')}>All Properties</button>
          <button className={filter === 'land' ? 'filter-btn active' : 'filter-btn'} onClick={() => setFilter('land')}>Land for Sale</button>
          <button className={filter === 'sale' ? 'filter-btn active' : 'filter-btn'} onClick={() => setFilter('sale')}>House for Sale</button>
          <button className={filter === 'rent' ? 'filter-btn active' : 'filter-btn'} onClick={() => setFilter('rent')}>House for Rent</button>
        </div>

        {(filter === 'all' || filter === 'land') && (
        <div>
          <h2>Land for Sale</h2>
          <div className="cards">
            {landsData.map(land => {
              const images = land.images && land.images.length > 0 ? land.images : [land.image];
              const currentIndex = currentImageIndex[land.id] || 0;
              console.log('Land', land.id, '- images array:', images.length, 'current index:', currentIndex);
              return (
              <div key={land.id} className={`card ${land.status === 'sold' ? 'sold-card' : ''} ${land.status === 'featured' ? 'featured-card' : ''}`}>
                <div className="card-img-wrapper">
                  <img 
                    src={images[currentIndex]} 
                    alt={land.title} 
                    className={`card-img ${land.status === 'sold' ? 'sold-img' : ''}`}
                    onClick={() => setLightboxImage(images[currentIndex])}
                  />
                  {images.length > 1 && (
                    <>
                      <button className="img-nav-btn prev" onClick={(e) => {
                        e.stopPropagation();
                        setCurrentImageIndex({...currentImageIndex, [land.id]: currentIndex === 0 ? images.length - 1 : currentIndex - 1});
                      }}>‹</button>
                      <button className="img-nav-btn next" onClick={(e) => {
                        e.stopPropagation();
                        setCurrentImageIndex({...currentImageIndex, [land.id]: currentIndex === images.length - 1 ? 0 : currentIndex + 1});
                      }}>›</button>
                      <div className="img-counter">{currentIndex + 1}/{images.length}</div>
                    </>
                  )}
                  {land.status === 'sold' && <div className="sold-badge">SOLD</div>}
                  {land.status === 'featured' && <div className="featured-badge">FEATURED</div>}
                </div>
                <div className="card-content">
                  <h3>{land.title}</h3>
                  <p><LocationIcon />{land.location}</p>
                  <p><RulerIcon />{land.size}</p>
                  <p className="price">{land.price}</p>
                  <button className="details-btn" onClick={() => setSelectedProperty(land)}>Get Details</button>
                </div>
              </div>
            )})}
          </div>
        </div>
        )}

        {(filter === 'all' || filter === 'sale') && (
        <div>
          <h2>Houses for Sale</h2>
          <div className="cards">
            {housesForSaleData.map(house => {
              const images = house.images && house.images.length > 0 ? house.images : [house.image];
              const currentIndex = currentImageIndex[house.id] || 0;
              return (
              <div key={house.id} className={`card ${house.status === 'sold' ? 'sold-card' : ''} ${house.status === 'featured' ? 'featured-card' : ''}`}>
                <div className="card-img-wrapper">
                  <img 
                    src={images[currentIndex]} 
                    alt={house.title} 
                    className={`card-img ${house.status === 'sold' ? 'sold-img' : ''}`}
                    onClick={() => setLightboxImage(images[currentIndex])}
                  />
                  {images.length > 1 && (
                    <>
                      <button className="img-nav-btn prev" onClick={(e) => {
                        e.stopPropagation();
                        setCurrentImageIndex({...currentImageIndex, [house.id]: currentIndex === 0 ? images.length - 1 : currentIndex - 1});
                      }}>‹</button>
                      <button className="img-nav-btn next" onClick={(e) => {
                        e.stopPropagation();
                        setCurrentImageIndex({...currentImageIndex, [house.id]: currentIndex === images.length - 1 ? 0 : currentIndex + 1});
                      }}>›</button>
                      <div className="img-counter">{currentIndex + 1}/{images.length}</div>
                    </>
                  )}
                  {house.status === 'sold' && <div className="sold-badge">SOLD</div>}
                  {house.status === 'featured' && <div className="featured-badge">FEATURED</div>}
                </div>
                <div className="card-content">
                  <h3>{house.title}</h3>
                  <p><LocationIcon />{house.location}</p>
                  <p><BedIcon />{house.beds} Beds<BathIcon />{house.baths} Baths</p>
                  <p className="price">{house.price}</p>
                  <button className="details-btn" onClick={() => setSelectedProperty(house)}>Get Details</button>
                </div>
              </div>
            )})}
          </div>
        </div>
        )}

        {(filter === 'all' || filter === 'rent') && (
        <div>
          <h2>Houses for Rent</h2>
          <div className="cards">
            {housesForRentData.map(house => {
              const images = house.images && house.images.length > 0 ? house.images : [house.image];
              const currentIndex = currentImageIndex[house.id] || 0;
              return (
              <div key={house.id} className={`card ${house.status === 'sold' ? 'sold-card' : ''} ${house.status === 'featured' ? 'featured-card' : ''}`}>
                <div className="card-img-wrapper">
                  <img 
                    src={images[currentIndex]} 
                    alt={house.title} 
                    className={`card-img ${house.status === 'sold' ? 'sold-img' : ''}`}
                    onClick={() => setLightboxImage(images[currentIndex])}
                  />
                  {images.length > 1 && (
                    <>
                      <button className="img-nav-btn prev" onClick={(e) => {
                        e.stopPropagation();
                        setCurrentImageIndex({...currentImageIndex, [house.id]: currentIndex === 0 ? images.length - 1 : currentIndex - 1});
                      }}>‹</button>
                      <button className="img-nav-btn next" onClick={(e) => {
                        e.stopPropagation();
                        setCurrentImageIndex({...currentImageIndex, [house.id]: currentIndex === images.length - 1 ? 0 : currentIndex + 1});
                      }}>›</button>
                      <div className="img-counter">{currentIndex + 1}/{images.length}</div>
                    </>
                  )}
                  {house.status === 'sold' && <div className="sold-badge">SOLD</div>}
                  {house.status === 'featured' && <div className="featured-badge">FEATURED</div>}
                </div>
                <div className="card-content">
                  <h3>{house.title}</h3>
                  <p><LocationIcon />{house.location}</p>
                  <p><BedIcon />{house.beds} Beds<BathIcon />{house.baths} Baths</p>
                  <p className="price">{house.price}</p>
                  <button className="details-btn" onClick={() => setSelectedProperty(house)}>Get Details</button>
                </div>
              </div>
            )})}
          </div>
        </div>
        )}
      </section>
      </>
      )}

      {page === 'land' && (
      <>
      <section className="hero">
        <div className="hero-content">
          <h2>Land for Sale</h2>
          <p>Find the perfect plot for your dream project</p>
        </div>
      </section>
      <section className="section">
        <div className="cards">
          {landsData.map(land => {
            const images = land.images && land.images.length > 0 ? land.images : [land.image];
            const currentIndex = currentImageIndex[land.id] || 0;
            return (
            <div key={land.id} className={`card ${land.status === 'sold' ? 'sold-card' : ''} ${land.status === 'featured' ? 'featured-card' : ''}`}>
              <div className="card-img-wrapper">
                <img 
                  src={images[currentIndex]} 
                  alt={land.title} 
                  className={`card-img ${land.status === 'sold' ? 'sold-img' : ''}`}
                  onClick={() => setLightboxImage(images[currentIndex])}
                />
                {images.length > 1 && (
                  <>
                    <button className="img-nav-btn prev" onClick={(e) => {
                      e.stopPropagation();
                      setCurrentImageIndex({...currentImageIndex, [land.id]: currentIndex === 0 ? images.length - 1 : currentIndex - 1});
                    }}>‹</button>
                    <button className="img-nav-btn next" onClick={(e) => {
                      e.stopPropagation();
                      setCurrentImageIndex({...currentImageIndex, [land.id]: currentIndex === images.length - 1 ? 0 : currentIndex + 1});
                    }}>›</button>
                    <div className="img-counter">{currentIndex + 1}/{images.length}</div>
                  </>
                )}
                {land.status === 'sold' && <div className="sold-badge">SOLD</div>}
                {land.status === 'featured' && <div className="featured-badge">FEATURED</div>}
              </div>
              <div className="card-content">
                <h3>{land.title}</h3>
                <p><LocationIcon />{land.location}</p>
                <p><RulerIcon />{land.size}</p>
                <p className="price">{land.price}</p>
                <button className="details-btn" onClick={() => setSelectedProperty(land)}>Get Details</button>
              </div>
            </div>
          )})}
        </div>
      </section>
      </>
      )}

      {page === 'sale' && (
      <>
      <section className="hero">
        <div className="hero-content">
          <h2>Houses for Sale</h2>
          <p>Discover your perfect home today</p>
        </div>
      </section>
      <section className="section">
        <h2>Houses for Sale</h2>
        <div className="cards">
          {housesForSaleData.map(house => {
            const images = house.images && house.images.length > 0 ? house.images : [house.image];
            const currentIndex = currentImageIndex[house.id] || 0;
            return (
            <div key={house.id} className={`card ${house.status === 'sold' ? 'sold-card' : ''} ${house.status === 'featured' ? 'featured-card' : ''}`}>
              <div className="card-img-wrapper">
                <img 
                  src={images[currentIndex]} 
                  alt={house.title} 
                  className={`card-img ${house.status === 'sold' ? 'sold-img' : ''}`}
                  onClick={() => setLightboxImage(images[currentIndex])}
                />
                {images.length > 1 && (
                  <>
                    <button className="img-nav-btn prev" onClick={(e) => {
                      e.stopPropagation();
                      setCurrentImageIndex({...currentImageIndex, [house.id]: currentIndex === 0 ? images.length - 1 : currentIndex - 1});
                    }}>‹</button>
                    <button className="img-nav-btn next" onClick={(e) => {
                      e.stopPropagation();
                      setCurrentImageIndex({...currentImageIndex, [house.id]: currentIndex === images.length - 1 ? 0 : currentIndex + 1});
                    }}>›</button>
                    <div className="img-counter">{currentIndex + 1}/{images.length}</div>
                  </>
                )}
                {house.status === 'sold' && <div className="sold-badge">SOLD</div>}
                {house.status === 'featured' && <div className="featured-badge">FEATURED</div>}
              </div>
              <div className="card-content">
                <h3>{house.title}</h3>
                <p><LocationIcon />{house.location}</p>
                <p><BedIcon />{house.beds} Beds<BathIcon />{house.baths} Baths</p>
                <p className="price">{house.price}</p>
                <button className="details-btn" onClick={() => setSelectedProperty(house)}>Get Details</button>
              </div>
            </div>
          )})}
        </div>
      </section>
      </>
      )}

      {page === 'rent' && (
      <>
      <section className="hero">
        <div className="hero-content">
          <h2>Houses for Rent</h2>
          <p>Find your ideal rental property</p>
        </div>
      </section>
      <section className="section">
        <h2>Houses for Rent</h2>
        <div className="cards">
          {housesForRentData.map(house => {
            const images = house.images && house.images.length > 0 ? house.images : [house.image];
            const currentIndex = currentImageIndex[house.id] || 0;
            return (
            <div key={house.id} className={`card ${house.status === 'sold' ? 'sold-card' : ''} ${house.status === 'featured' ? 'featured-card' : ''}`}>
              <div className="card-img-wrapper">
                <img 
                  src={images[currentIndex]} 
                  alt={house.title} 
                  className={`card-img ${house.status === 'sold' ? 'sold-img' : ''}`}
                  onClick={() => setLightboxImage(images[currentIndex])}
                />
                {images.length > 1 && (
                  <>
                    <button className="img-nav-btn prev" onClick={(e) => {
                      e.stopPropagation();
                      setCurrentImageIndex({...currentImageIndex, [house.id]: currentIndex === 0 ? images.length - 1 : currentIndex - 1});
                    }}>‹</button>
                    <button className="img-nav-btn next" onClick={(e) => {
                      e.stopPropagation();
                      setCurrentImageIndex({...currentImageIndex, [house.id]: currentIndex === images.length - 1 ? 0 : currentIndex + 1});
                    }}>›</button>
                    <div className="img-counter">{currentIndex + 1}/{images.length}</div>
                  </>
                )}
                {house.status === 'sold' && <div className="sold-badge">SOLD</div>}
                {house.status === 'featured' && <div className="featured-badge">FEATURED</div>}
              </div>
              <div className="card-content">
                <h3>{house.title}</h3>
                <p><LocationIcon />{house.location}</p>
                <p><BedIcon />{house.beds} Beds<BathIcon />{house.baths} Baths</p>
                <p className="price">{house.price}</p>
                <button className="details-btn" onClick={() => setSelectedProperty(house)}>Get Details</button>
              </div>
            </div>
          )})}
        </div>
      </section>
      </>
      )}

      {page === 'about' && (
      <>
      <section className="hero">
        <div className="hero-content">
          <h2>About Us</h2>
          <p>Your trusted real estate partner</p>
        </div>
      </section>
      <section id="about" className="section about">
        <h2>About Us</h2>
        <p>Paka Real Estate is your trusted partner in finding the perfect property. With years of experience in the real estate industry, we specialize in helping clients buy, sell, and rent properties with complete ease and confidence.</p>
        <p>Our team of dedicated professionals is committed to providing exceptional service, expert guidance, and personalized solutions tailored to your unique needs. Whether you're looking for your dream home, investment property, or the perfect rental, we're here to make your real estate journey smooth and successful.</p>
        <p>We pride ourselves on our integrity, market knowledge, and commitment to client satisfaction. Trust Paka Real Estate to turn your property dreams into reality.</p>
      </section>
      </>
      )}

      {page === 'contact' && (
      <>
      <section className="hero">
        <div className="hero-content">
          <h2>Contact Us</h2>
          <p>Get in touch with our team</p>
        </div>
      </section>
      <section id="contact" className="section contact">
        <h2>Contact Us</h2>
        <p>Get in touch with us for all your real estate needs</p>
        <div className="contact-info">
          <p><EmailIcon />Email: pakarealestate@gmail.com</p>
          <p><PhoneIcon />Call: +91 80560 41236</p>
          <p><MessageIcon />WhatsApp: +91 7200504251</p>
          <p><MapPinIcon />Address: 01, First Floor, Kareem Complex, Pudupattinam, Kalpakkam, 603102</p>
          <div className="social-links">
            <a href="https://www.instagram.com/paka_real_estate/?utm_source=ig_web_button_share_sheet" target="_blank" rel="noopener noreferrer"><InstagramIcon />Instagram</a>
            <a href="http://www.youtube.com/@Paka-Architects" target="_blank" rel="noopener noreferrer"><YoutubeIcon />YouTube</a>
          </div>
        </div>
      </section>
      </>
      )}

      {page === 'login' && !isAdmin && (
      <section className="section login">
        <div className="login-container">
          <h2>Admin Login</h2>
          <form onSubmit={handleLogin}>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit" className="login-btn">Login</button>
          </form>
        </div>
      </section>
      )}

      {page === 'admin' && isAdmin && (
      <section className="section admin">
        <div className="admin-header">
          <h2>Admin Dashboard</h2>
          <button onClick={handleLogout} className="logout-btn">Logout</button>
        </div>
        <div className="admin-stats">
          <div className="stat-card">
            <h3>{landsData.length}</h3>
            <p>Land Listings</p>
          </div>
          <div className="stat-card">
            <h3>{housesForSaleData.length}</h3>
            <p>Houses for Sale</p>
          </div>
          <div className="stat-card">
            <h3>{housesForRentData.length}</h3>
            <p>Houses for Rent</p>
          </div>
          <div className="stat-card">
            <h3>{landsData.length + housesForSaleData.length + housesForRentData.length}</h3>
            <p>Total Properties</p>
          </div>
        </div>
        <div className="admin-actions">
          <button className="action-btn" onClick={() => { setShowAddForm(!showAddForm); setEditingProperty(null); setNewProperty({ category: 'land', title: '', location: '', price: '', image: '', images: [], size: '', beds: '', baths: '', status: 'active' }); }}>
            {showAddForm ? 'Cancel' : 'Add New Property'}
          </button>
        </div>

        {showAddForm && (
        <div className="property-form">
          <h3>{editingProperty ? 'Edit Property' : 'Add New Property'}</h3>
          <form onSubmit={handleAddProperty}>
            <select
              value={newProperty.category}
              onChange={(e) => setNewProperty({ ...newProperty, category: e.target.value })}
              required
            >
              <option value="land">Land for Sale</option>
              <option value="sale">House for Sale</option>
              <option value="rent">House for Rent</option>
            </select>

            <select
              value={newProperty.status}
              onChange={(e) => setNewProperty({ ...newProperty, status: e.target.value })}
              required
            >
              <option value="active">Active</option>
              <option value="featured">Featured</option>
              <option value="sold">Sold</option>
            </select>

            <input
              type="text"
              placeholder="Title"
              value={newProperty.title}
              onChange={(e) => setNewProperty({ ...newProperty, title: e.target.value })}
              required
            />

            <input
              type="text"
              placeholder="Location"
              value={newProperty.location}
              onChange={(e) => setNewProperty({ ...newProperty, location: e.target.value })}
              required
            />

            <input
              type="text"
              placeholder="Price (e.g., $50,000 or $1,200/mo)"
              value={newProperty.price}
              onChange={(e) => setNewProperty({ ...newProperty, price: e.target.value })}
              required
            />

            <div className="image-upload">
              <label htmlFor="image-input" className="upload-label">
                {newProperty.images.length > 0 ? <><CheckIcon />{newProperty.images.length} Images Uploaded</> : <><CameraIcon />Upload Images (Multiple)</>}
              </label>
              <input
                id="image-input"
                type="file"
                accept="image/*"
                multiple
                onChange={handleImageUpload}
                className="file-input"
              />
            </div>
            {newProperty.images.length > 0 && (
              <div className="images-preview">
                {newProperty.images.map((img, index) => (
                  <div key={index} className="preview-item">
                    <img src={img} alt={`Preview ${index + 1}`} className="image-preview" />
                    <button type="button" className="remove-img-btn" onClick={() => removeImage(index)}>×</button>
                  </div>
                ))}
              </div>
            )}

            {newProperty.category === 'land' && (
              <input
                type="text"
                placeholder="Size (e.g., 5 acres)"
                value={newProperty.size}
                onChange={(e) => setNewProperty({ ...newProperty, size: e.target.value })}
                required
              />
            )}

            {(newProperty.category === 'sale' || newProperty.category === 'rent') && (
              <>
                <input
                  type="number"
                  placeholder="Number of Bedrooms"
                  value={newProperty.beds}
                  onChange={(e) => setNewProperty({ ...newProperty, beds: e.target.value })}
                  required
                />
                <input
                  type="number"
                  placeholder="Number of Bathrooms"
                  value={newProperty.baths}
                  onChange={(e) => setNewProperty({ ...newProperty, baths: e.target.value })}
                  required
                />
              </>
            )}

            <button type="submit" className="submit-btn">{editingProperty ? 'Update Property' : 'Add Property'}</button>
          </form>
        </div>
        )}

        <div className="properties-table">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
            <h3 style={{ margin: 0 }}>All Properties</h3>
            <select 
              value={adminFilter} 
              onChange={(e) => setAdminFilter(e.target.value)}
              style={{ padding: '0.6rem 1rem', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.1)', background: 'rgba(255,255,255,0.8)', fontSize: '0.95rem', cursor: 'pointer' }}
            >
              <option value="all">All Properties</option>
              <option value="land">Land for Sale</option>
              <option value="sale">House for Sale</option>
              <option value="rent">House for Rent</option>
            </select>
          </div>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Image</th>
                <th>Images</th>
                <th>Title</th>
                <th>Category</th>
                <th>Location</th>
                <th>Price</th>
                <th>Details</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {allProperties.filter(p => adminFilter === 'all' || p.category === adminFilter).map(property => (
                <tr key={property.id}>
                  <td>#{property.id}</td>
                  <td><img src={property.image} alt={property.title} className="table-img" /></td>
                  <td>{property.images?.length || 0} imgs</td>
                  <td>{property.title}</td>
                  <td>{property.category === 'land' ? 'Land' : property.category === 'sale' ? 'House Sale' : 'House Rent'}</td>
                  <td>{property.location}</td>
                  <td>{property.price}</td>
                  <td>{property.size || `${property.beds} Beds, ${property.baths} Baths`}</td>
                  <td>
                    <span className={`status-badge ${property.status}`}>
                      {property.status === 'featured' ? 'Featured' : property.status === 'sold' ? 'Sold' : 'Active'}
                    </span>
                  </td>
                  <td>
                    <button className="edit-btn" onClick={() => handleEditProperty(property)}>Edit</button>
                    <button className="delete-btn" onClick={() => handleDeleteProperty(property.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
      )}

      {lightboxImage && (
        <div className="lightbox-overlay" onClick={() => setLightboxImage(null)}>
          <button className="lightbox-close" onClick={() => setLightboxImage(null)}>×</button>
          <img src={lightboxImage} alt="Full size" className="lightbox-img" onClick={(e) => e.stopPropagation()} />
        </div>
      )}

      {selectedProperty && (
        <div className="modal-overlay" onClick={() => setSelectedProperty(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedProperty(null)}>×</button>
            <img src={selectedProperty.image} alt={selectedProperty.title} className="modal-img" />
            <h3>{selectedProperty.title}</h3>
            <p className="modal-location"><LocationIcon />{selectedProperty.location}</p>
            <p className="modal-price">{selectedProperty.price}</p>
            <p className="modal-subtitle">Contact us for more details</p>
            <div className="contact-buttons">
              <a href="tel:+918056041236" className="contact-btn call-btn">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                </svg>
                <span>Call Now</span>
              </a>
              <a href="https://wa.me/917200504251" target="_blank" rel="noopener noreferrer" className="contact-btn whatsapp-btn">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
                <span>WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
      )}

      <footer className="footer">
        <p>&copy; 2024 Paka Real Estate. All rights reserved.</p>
        <p>Contact: pakarealestate@gmail.com | +91 80560 41236</p>
      </footer>
    </div>
  );
}

export default App;
